import type { CPhotoGalleryTranslations } from "./pl";

/**
 * CPhotoGallery - deutsche Übersetzungen (Fotogalerie - Galerieliste + Galerie).
 */
export const de: CPhotoGalleryTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Galerien zum Anzeigen.",
  emptyGallery: "Diese Galerie enthält noch keine Fotos.",
  backToList: "<- Zurück zur Galerieliste",
  openImage: "Bild öffnen",
  /** `photosCount(5)` -> "5 Fotos". */
  photosCount: (n: number): string => `${n} ${n === 1 ? "Foto" : "Fotos"}`,
  paginationAria: "Seitennummerierung",
  /** `paginationLabel(2, 7)` -> "Seite 2 von 7". */
  paginationLabel: (page: number, totalPages: number) =>
    `Seite ${page} von ${totalPages}`,
  paginationHint: "Die Seitennummerierung wird in einer späteren Iteration angebunden",
};
